export default{
    changeAuth(state,params){
        state.auth  = params
    },
    changePlainclothes(state,params){
        state.plainclothes = params
    },
    changeProfile(state,params){
        state.profile  = params
    },
    changeOwnActive(state,params){
        state.ownActive  = params
    },
    changeCartSource(state,params){
        state.cart[params['platform_id']]  = params.dataSource
    },
    changeCategorySource(state,params){
        state.category[params['taxonomy']]  = params.dataSource
    },
    changeIndustrySource(state,params){
        state.industry  = params
    },
    changeCartLoading(state,params){
        state.cartLoading = params
    },
    changeCartPlatform(state,params){
        state.cartPlatform = params
    },
    changeCustomerService(state,params){
        state.customerService = params
    },
    changeResTbOption(state,params){
        state.resTableOption[params['key']] = params['value']
    }         
}